import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {IFilterQueryCSR} from '../core/_models'
import {enableMapSet} from 'immer'

enableMapSet()
export interface CSRFilterState {
  query: IFilterQueryCSR
}

const initialState: IFilterQueryCSR = {group_by: 'day'}

const csrFilterSlice = createSlice({
  name: 'csrFilter',
  initialState: initialState,
  reducers: {
    updateQuery(state, action: PayloadAction<Partial<IFilterQueryCSR>>) {
      Object.assign(state, action.payload)
    },
    setQuery(state, action: PayloadAction<IFilterQueryCSR>) {
      return action.payload
    },

    resetQuery() {
      return initialState
    },
  },
})

export const {resetQuery, setQuery, updateQuery} = csrFilterSlice.actions
export default csrFilterSlice.reducer
